// Module
var code = `<select class="gl-category-select"
  ng-if = "!\$ctrl.isSelectize"
  ng-model="\$ctrl.category"
  ng-change="\$ctrl.valueChanged()"
  ng-disabled="\$ctrl.\$attrs.disabled"
  ng-options="c as c.name for c in \$ctrl.categories"
>
</select>
<selectize class="nx-selectize"
  ng-if = "\$ctrl.isSelectize"
  options="\$ctrl.categories"
  ng-model="\$ctrl.categoryId"
  config="\$ctrl.actionCategorySelectizeConfig"
  ng-change="\$ctrl.valueChanged()"
  ng-disabled="\$ctrl.\$attrs.disabled"
  ng-required="\$ctrl.\$attrs.required"
>
</selectize>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/general-ledger/common/gl-category-select.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;